@let d = details();
<div class="flex flex-col gap-3 p-4 text-sm" data-testid="event-detail">
  <!-- when + status -->
  <div class="flex items-center justify-between gap-3 rounded-lg border bg-surface p-3">
    <div class="flex items-center gap-3 min-w-0">
      <div
        class="flex items-center justify-center size-10 rounded-lg bg-purple-100 text-purple-700 dark:bg-purple-500/20 dark:text-purple-200 shrink-0"
      >
        <soft-ds-icon name="fa-regular fa-calendar-clock" />
      </div>
      <div class="flex flex-col min-w-0">
        @if (d.allDay) {
          <span class="font-semibold">{{ d.start | date: 'dd.MM.yyyy' }}</span>
          <span class="text-light">Ganztägig</span>
        } @else if (sameDay()) {
          <span class="font-semibold">{{ d.start | date: 'dd.MM.yyyy' }}</span>
          <span class="text-light">
            {{ d.start | date: 'HH:mm' }} - {{ d.end | date: 'HH:mm' }}
          </span>
        } @else {
          <span class="font-semibold">
            {{ d.start | date: 'dd.MM.yyyy, HH:mm' }} -
            {{ d.end | date: 'dd.MM.yyyy, HH:mm' }}
          </span>
        }
      </div>
    </div>
    @if (statusLabel(); as status) {
      <span
        class="shrink-0 inline-flex items-center rounded-full bg-purple-100 text-purple-800 dark:bg-purple-500/20 dark:text-purple-200 px-2 py-0.5 text-xs font-semibold"
      >
        {{ status }}
      </span>
    }
  </div>

  <!-- details -->
  @if (d.location || d.organizer || d.attendees?.length) {
    <div class="flex flex-col rounded-lg border bg-surface divide-y">
      @if (d.location) {
        <div class="flex items-start gap-3 p-3">
          <soft-ds-icon
            class="text-light mt-0.5 w-4 text-center shrink-0"
            name="fa-regular fa-location-dot"
          />
          <div class="flex flex-col min-w-0">
            <span class="text-xs text-light">Ort</span>
            <span class="break-words">{{ d.location }}</span>
          </div>
        </div>
      }

      @if (d.organizer) {
        <div class="flex items-start gap-3 p-3">
          <soft-ds-icon
            class="text-light mt-0.5 w-4 text-center shrink-0"
            name="fa-regular fa-user"
          />
          <div class="flex flex-col min-w-0">
            <span class="text-xs text-light">Organisator</span>
            <span class="break-words">{{ d.organizer }}</span>
          </div>
        </div>
      }

      @if (d.attendees?.length) {
        <div class="flex items-start gap-3 p-3">
          <soft-ds-icon
            class="text-light mt-0.5 w-4 text-center shrink-0"
            name="fa-regular fa-users"
          />
          <div class="flex flex-col min-w-0">
            <span class="text-xs text-light">Teilnehmer</span>
            <span class="break-words">{{ d.attendees?.join(', ') }}</span>
          </div>
        </div>
      }
    </div>
  }

  <!-- online meeting -->
  @if (d.onlineMeetingUrl) {
    <a
      class="flex items-center justify-center gap-2 rounded-lg border bg-surface p-3 font-semibold text-primary hover:bg-hover"
      [href]="d.onlineMeetingUrl"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="event-detail-meeting-link"
    >
      <soft-ds-icon name="fa-regular fa-video" />
      Besprechung öffnen
    </a>
  }

  <!-- description -->
  @if (d.description) {
    <div class="rounded-lg border bg-surface p-3">
      <span class="text-xs text-light">Beschreibung</span>
      <!-- Angular's default sanitization keeps the HTML safe -->
      <div
        class="mt-1.5 leading-relaxed break-words"
        [innerHTML]="d.description"
      ></div>
    </div>
  }
</div>
